import { context, propagation, trace } from "@opentelemetry/api";
import { ZoneContextManager } from "@opentelemetry/context-zone";
import { W3CTraceContextPropagator } from "@opentelemetry/core";
import { OTLPTraceExporter } from "@opentelemetry/exporter-trace-otlp-http";
import { registerInstrumentations } from "@opentelemetry/instrumentation";
import { FetchInstrumentation } from "@opentelemetry/instrumentation-fetch";
import { resourceFromAttributes } from "@opentelemetry/resources";
import { BatchSpanProcessor, TracerProvider } from "@opentelemetry/sdk-trace";

export function initTelemetry(): void {
  const resource = resourceFromAttributes({
    "service.name": "scaleupxq-frontend",
  });

  const spanProcessors = [
    new BatchSpanProcessor({
      exporter: new OTLPTraceExporter({ url: "/api/v1/telemetry/traces" }),
    }),
  ];

  // SDK 3 dropped WebTracerProvider and its register(); wire the globals here.
  trace.setGlobalTracerProvider(new TracerProvider({ resource, spanProcessors }));
  context.setGlobalContextManager(new ZoneContextManager().enable());
  propagation.setGlobalPropagator(new W3CTraceContextPropagator());

  registerInstrumentations({
    instrumentations: [
      new FetchInstrumentation({
        // Don't trace the telemetry endpoint itself (avoids infinite loop)
        ignoreUrls: [/\/telemetry\/traces/, /\/assets\//, /\/healthz/],
        propagateTraceHeaderCorsUrls: [/.*/],
        clearTimingResources: true,
      }),
    ],
  });
}
